module.exports = __webpack_public_path__ + "img/bp_aura.776e3756.jpg";